import { ConfiguracaoDeTexto, ParametrosGerais, TextoModel } from "../models/textoModel"

export enum TextoImpressaoActionsTypes {
    INICIAL = "INICIAL",
    ATUALIZAR = "ATUALIZAR",
    RESETAR = "RESETAR",
    TOGGLE_ATIVO = "TOGGLE_ATIVO",
    TOGGLE_NEGRITO = "TOGGLE_NEGRITO",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    ATUALIZAR_PARAMETROS_GERAIS = "ATUALIZAR_PARAMETROS_GERAIS",
}

export type CampoTextoImpressao = keyof Omit<TextoModel, "id" | "parametrosGerais">

export type TextoImpressaoActionModel =
    | {
          type: TextoImpressaoActionsTypes.INICIAL
          payload: TextoModel
      }
    | {
          type: TextoImpressaoActionsTypes.ATUALIZAR
          payload: TextoModel
      }
    | {
          type: TextoImpressaoActionsTypes.TOGGLE_ATIVO
          payload: { campo: CampoTextoImpressao }
      }
    | {
          type: TextoImpressaoActionsTypes.TOGGLE_NEGRITO
          payload: { campo: CampoTextoImpressao }
      }
    | {
          type: TextoImpressaoActionsTypes.ATUALIZAR_CAMPO
          payload: {
              campo: CampoTextoImpressao
              propriedade: keyof ConfiguracaoDeTexto
              valor: boolean | number
          }
      }
    | {
          type: TextoImpressaoActionsTypes.ATUALIZAR_PARAMETROS_GERAIS
          payload: {
              propriedade: keyof ParametrosGerais
              valor: boolean | number | string
          }
      }
    | {
          type: TextoImpressaoActionsTypes.RESETAR
      }
